export default "__VITE_ASSET__Tzze83qk__"